<template>
  <div>
    <v-flex xs12 v-if="terc.length === 6">
      <v-autocomplete
        clearable
        v-model="selectedSIMC"
        item-text="name"
        item-value="symbol"
        :items="cities"
        :label="label"
        :errorMessages="this.model.city.$error"
        @focus="focus('city')"
        @blur="blur('city')"
        @change="changeCity"
      ></v-autocomplete>
    </v-flex>
  </div>
</template>

<script>
import axios from 'axios';

import { notificationsMixin } from '@/mixins/notifications';

// @vuese
// Input na SIMC-a
// @group Components/Forms
export default {
  mixins: [notificationsMixin],
  props: {
    // Schema
    model: {
      type: Object,
      required: true
    },
    // Nazwa pola z SIMC-em
    field: {
      type: String,
      required: false,
      default: 'simc'
    },
    // Wartość TERC-a
    terc: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      cities: [],
      selectedSIMC: undefined,
      label: this.model[this.field].$schema.fieldRequired ? 'Miejscowość *' : 'Miejscowość'
    };
  },
  methods: {
    // @vuese
    // Pobiera listę miejscowości
    getSIMCList() {
      if (this.terc.length === 6) {
        axios
          .get(`${process.env.VUE_APP_TERYT_API_URL}/simc/?terc=${this.terc}`)
          .then(res => {
            this.cities = res.data.list;
            if (this.cities.length === 1) {
              this.selectedSIMC = this.cities[0].symbol;
              this.changeCity(this.cities[0].symbol);
            }
          })
          .catch(error => this.notifyError('Nie udało się pobrać listy miejscowości'));
      } else {
        this.cleanSIMC();
      }
    },
    // @vuese
    // Wyczyszczenie formularza
    cleanSIMC() {
      this.cities = [];
      this.selectedSIMC = undefined;
      this.model.$setData({
        city: '',
        [this.field]: ''
      });
    },
    // @vuese
    // Ustawianie pól formularza
    setSIMCData() {
      this.selectedSIMC = this.model[this.field].$value;
    },
    // @vuese
    // Zapisanie w schema i wyczyszczenie odpowiednich pól po wybraniu miejscowości
    changeCity(val) {
      this.model.$setData({
        city: val ? this.cities.find(item => item.symbol === val).name : '',
        [this.field]: val ? val : ''
      });
    },
    focus(field) {
      this.model[field].$hasFocus = true;
    },
    blur(field) {
      this.model[field].$hasFocus = false;
    }
  },
  watch: {
    terc(newValue) {
      if (newValue) {
        this.getSIMCList();
      } else {
        this.cleanSIMC();
      }
    }
  },
  beforeMount() {
    this.getSIMCList();
    this.setSIMCData();
  }
};
</script>
